import React, {Component} from 'react';
import {Query} from 'react-apollo';
import {Link} from 'react-router-dom';
import {reach} from '@hapi/hoek';
import gql from 'graphql-tag';
import withQuery from 'utils/withQuery';
import {sortByMostRecent} from 'utils/utils';
import {HomeRouteContext} from 'utils/context';
import SectionTitle from '../SectionTitle/SectionTitle';
import AspectRatioImage from '../AspectRatioImage/AspectRatioImage';
import './RelatedArticles.less';

export const query = gql`
    query articlesByCategory($categoryId: String) {
        articleCollection(where: {parentId: $categoryId}) {
            items {
                headline
                overview
                path
                heroFile {
                    url
                    title
                }
                parent {
                    name
                    path
                }
                datePublishedCustom
            }
        }
    }
`;

const RelatedArticlesLoaded = (props) => {
    const {
        title,
        slug,
        response: {
            data: {articleCollection},
        },
    } = props;
    const articles = reach(articleCollection, 'items').filter(
        (article) => article.path !== slug,
    );

    if (articles && articles.length > 3) {
        return (
            <section className="RelatedArticles hub-section">
                <SectionTitle title={title} noIcon />
                <div className="RelatedArticles__article-list">
                    {sortByMostRecent(articles).map((item, idx) => {
                        return (
                            <HomeRouteContext.Consumer key={idx}>
                                {(homeRoute) => (
                                    <Link
                                        to={`${homeRoute}${item.path}`}
                                        className="RelatedArticles__content-container"
                                    >
                                        {item.heroFile && (
                                            <AspectRatioImage
                                                {...item.heroFile}
                                            />
                                        )}
                                        <h4 className="RelatedArticles__title">
                                            <span className="heading-hover-bg">
                                                {item.headline}
                                            </span>
                                        </h4>
                                    </Link>
                                )}
                            </HomeRouteContext.Consumer>
                        );
                    })}
                </div>
            </section>
        );
    }

    return null;
};

const RelatedArticlesWithLoading = withQuery(RelatedArticlesLoaded);

export default class RelatedArticles extends Component {
    render() {
        const homeRoute = this.context;
        const {category: categoryId, ...rest} = this.props;
        const variables = {categoryId};

        return (
            <Query {...{query, variables}}>
                {(response) => {
                    return (
                        <RelatedArticlesWithLoading
                            {...{...rest, response, homeRoute}}
                        />
                    );
                }}
            </Query>
        );
    }
}
